module.exports = __webpack_public_path__ + "static/media/tick-inactive.e3d2034c.svg";